<form [formGroup]="issuesNameForm">
  <h4 class="title">{{ "teams.generalTab.TitleApp" | translate }}</h4>

  <div class="rename-issue">
    <mat-form-field class="rename-issue-control">
      <mat-label>{{ "teams.LocatePackage.IssueSingularName" | translate }}</mat-label>
      <input formControlName="IssueDisplayName" matInput />
      <mat-error *ngIf="getFormError(IssueNameErrors.IssueSingularNameRequired)">{{
          "teams.LocatePackage.IssueSingularNameRequired" | translate
        }}</mat-error>
    </mat-form-field>

    <mat-form-field class="rename-issue-control">
      <mat-label>{{ "teams.LocatePackage.IssuePluralName" | translate }}</mat-label>
      <input formControlName="IssueDisplayNamePlural" matInput />
      <mat-error *ngIf="getFormError(IssueNameErrors.IssuePluralNameRequired)">{{
          "teams.LocatePackage.IssuePluralNameRequired" | translate
        }}</mat-error>
    </mat-form-field>
  </div>
</form>
